import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { downloadFile } from '$/store/export/actions';
import { toastError } from '$/store/toast/actions';
import * as Bixby from '$/core';
import { getIsCurrentUserAdminState } from '$/store/profile/selectors';
import { getIsCurrentPortfolioCompanyPublicState } from '$/store/portfolio/selectors';
import ClientCompanyDocumentsList from '$/components/client-company-documents-list';
import { DocumentsClientService } from '$/services';
import './index.scss';

interface ICompanyDocumentsProps {
  currentCompany?: Bixby.Models.Company;
  profile?: Bixby.Models.Profile;
  featureFlags?: string[];
  isAdmin: boolean;
  isCurrentPortfolioCompanyPublic: boolean;
  dispatchDownloadDocument: (blob: Blob, fileName: string) => Promise<void>;
  dispatchDownloadFailure: () => Promise<void>;
}

const CompanyDocuments: React.FC<ICompanyDocumentsProps> = props => {
  const { currentCompany } = props;
  const getCompanyDocuments = async (id: string) => await DocumentsClientService.getDocumentsByCompanyId(id);

  const downloadAllDocuments = async (id: string) => {
    if (!props.currentCompany) return;

    const { blob, filename } = await DocumentsClientService.downloadAllAsZip(id);
    await props.dispatchDownloadDocument(blob, filename || 'documents.zip');
  };

  return (
    <>
      {currentCompany && !Bixby.Utils.isNullOrEmpty(currentCompany.documentAnnouncement) && (
        <div className="company_document_announcement">
          <div
            className="document_announcement"
            dangerouslySetInnerHTML={{ __html: currentCompany.documentAnnouncement }}
          />
        </div>
      )}
      <ClientCompanyDocumentsList
        {...props}
        getCompanyDocuments={getCompanyDocuments}
        downloadAllDocuments={downloadAllDocuments}
      />
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  const { isAdmin } = getIsCurrentUserAdminState(state);
  const { isCurrentPortfolioCompanyPublic } = getIsCurrentPortfolioCompanyPublicState(state);

  return {
    currentCompany: state.portfolioState.currentCompany,
    isLoading: state.portfolioState.isLoading,
    error: state.portfolioState.error,
    profile: state.profileState.profile,
    featureFlags: state.loginState.featureFlags,
    isCurrentPortfolioCompanyPublic,
    isAdmin,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchDownloadDocument: (blob: Blob, fileName: string) => dispatch(downloadFile(blob, fileName)),
  dispatchDownloadFailure: () => dispatch(toastError('Failed to download document')),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDocuments);
